<template>
  <div id="addInterviewByJobModal" class="modal fade">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content col-lg-10 ">
        <div class="modal-header pd-x-20">
          <h6 class="modal-title">面试邀约</h6>
        </div>
        <div class="modal-body pd-20">

          <div class="form-group">
            <label class="form-label" style="text-align: left;"><i class="fa fa-star inbox-started"></i>职位</label>
            <select name="country" id="select-countries" class="form-control col-6" style="width: 300px" v-model="interview.jobId">
              <option value="" selected>--请选择--</option>
              <option v-for="item of pubJobs" v-text="item.jobName" :value="item.id"></option>
            </select>
            <div class="invalid-feedback">请选择邀约职位</div>
          </div>

          <div class="form-group">
            <label class="form-label" style="text-align: left;"><i class="fa fa-star inbox-started"></i>面试时间</label>
            <date-picker v-model="interview.timeStart" type="datetime" class="form-control col-6" style="width: 300px" :format="'YYYY-MM-DD HH:mm:ss'" :value-type="'format'">
            </date-picker>
            <div class="invalid-feedback">请选择面试时间</div>
          </div>

          <div class="form-group">
            <label class="form-label" style="text-align: left;"><i class="fa fa-star inbox-started"></i>联系人</label>
            <input  type="text" style="width: 300px" class="form-control col-6" v-model="interview.cp" >
          </div>

          <div class="form-group">
            <label class="form-label" style="text-align: left;"><i class="fa fa-star inbox-started"></i>联系电话</label>
            <input  type="text" style="width: 300px" class="form-control col-6" v-model="interview.cm" >
          </div>

          <div class="form-group">
            <label class="form-label" style="text-align: left;"><i class="fa fa-star inbox-started"></i>详细地址</label>
            <input  type="text" style="width: 300px" class="form-control col-6" v-model="interview.cd" >
          </div>

          <div class="form-group">
            <label class="form-label" style="text-align: left;">备注</label>
            <textarea style="width: 300px" class="form-group col-10 " name="work-detail" rows="2" cols="20"
                      placeholder="备注信息" v-model="interview.interviewRemark">
                    </textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="addInterviewInfo">发送</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {addInterviewByJob,getJobViewLists} from '@/api/job'
    import {getEnterpriseInfo} from '@/api/enterprise'
    import {isEmpty} from "@/api/validator";
    import DatePicker from 'vue2-datepicker'
    import Toastr from "toastr2";

    export default {
        name: 'add_interview_by_job',
        data() {
            return {
                interview: {
                    jobId: "",
                    timeStart: "",
                    interviewRemark: "",
                    cp: "",
                    cm: "",
                    cd: ""
                },
                queryJobs: {
                    enterpriseId: "",
                    jobTypes: [],
                    industrys: [],
                    testBenifit: [],
                    holidayDays: [],
                    workPlaceTrip: [],
                    ad: {
                        prov: "",
                        city: "",
                        subs: ""
                    }
                },
                pubJobs:[],
                check: {
                    hasSubmit: true,
                    timeStartValid: false,
                    jobIdV:false
                },
                companyInfo:{}
            }
        },
        props: ['cvId']
        ,
        components:{DatePicker},
        mounted() {
        },
        methods: {
            addInterviewInfo() {
                const toast = new Toastr()

                if(this.interview.jobId == null || this.interview.jobId == "" || this.interview.jobId == undefined){
                    toast.warning("请选择邀请的职位!");
                    return
                }

                if(this.interview.timeStart == null || this.interview.timeStart == "" || this.interview.timeStart == undefined){
                    toast.warning("请选择邀请时间!");
                    return
                }

                this.interview['cvId'] = this.cvId
                this.interview['fairId'] = localStorage.getItem("currentFairId");
                addInterviewByJob(this.interview).then(response => {
                    toast.info("面试邀请发送成功!");
                }).catch(error => {
                    toast.warning("面试邀请发送失败!");
                })
            },
            getPubJob(id){
                this.queryJobs.enterpriseId = id;
                getJobViewLists(this.queryJobs).then(response=>{
                    this.pubJobs = response.pageResult.data
                }).catch(error => {
                    this.record = {}
                })
            },
            getEntInfo(id){
                    getEnterpriseInfo({id: id}).then(response => {
                        this.companyInfo = response.record
                        this.interview.cp = this.companyInfo.enterpriseManager
                        this.interview.cm = this.companyInfo.enterpriseContactPhone
                        this.interview.cd = this.companyInfo.enterpriseAddress

                    }).catch(err => {
                        console.log(err)
                    })
            }
        },
        watch:{
            interview:{
                handler(val, oldVal){

                    if(!isEmpty(val.jobId)){
                        this.check.jobIdV=true;
                    }else {
                        this.check.jobIdV=false;
                    }

                    if(val.timeStart != null && val.timeStart != ""){
                        this.check.timeStartValid=true;
                    }else {
                        this.check.timeStartValid=false;
                    }
                },
                deep:true
            }
        }
    }
</script>

<style scoped>
  .btn-success {
    color: #fff;
    background: #9ac043;
    border-color: #9ac043;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/job/add_interview_job2.vue